<template>
  <div class="multiselect-wrapper">
    <vue-multiselect
        v-model="objectValue"
        :options="selectOptions"
        :label="label"
        :track-by="trackBy"
        :open-direction="openDirection"
        :searchable="true"
        :disabled="disabled"
        :allow-empty="allowEmpty"
        :placeholder=null
        select-label="Wybierz"
        deselect-label="Odznacz"
        selected-label="Wybrane"
    >
      <span slot="noResult">Brak wyników. Spróbuj zmienić wpisywaną frazę.</span>
    </vue-multiselect>
    <div v-show="isPlaceholderVisible" class="multiselect-placeholder">{{ placeholder }}</div>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
  components: {
    VueMultiselect
  },
  props: {
    value: {
      required: true,
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'name'
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    checked: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    sortBy: {
      type: String,
      default: null,
    },
    openDirection: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
    }
  },
  data: function () {
    return {
      selectOptions: this.generateOptions(this.options),
    }
  },
  watch : {
    options: function(options) {
      this.selectOptions = this.generateOptions(options)
    },
  },
  computed: {
    objectValue: {
      get: function () {
        return this.prepareValue(this.value)
      },
      set: function (value) {
        if (value) {
          this.$emit('input', value.id)
        } else {
          this.$emit('input', null)
        }
      }
    },
    isPlaceholderVisible() {
      return this.placeholder && !this.value
    },
  },
  methods: {
    generateOptions(options) {
      let generatedOptions = typeof options === 'object' ? Object.values(options) : options
      if (this.sortBy) {
        let sortBy = this.sortBy
        generatedOptions.sort((a, b) => a[sortBy] - b[sortBy])
      }
      return generatedOptions
    },
    prepareValue(id) {
      let prepareValue = {}
      prepareValue[this.trackBy] = id
      for (let i = 0; i < this.selectOptions.length; i++) {
        if (this.selectOptions[i][this.trackBy] === id) {
          prepareValue[this.label] = this.selectOptions[i][this.label]
        }
      }
      return prepareValue
    }
  },
}
</script>

<style scoped>
.multiselect-wrapper {
  position: relative;
}

.multiselect-wrapper .multiselect-placeholder {
  color: #ccc;
  height: 100%;
  line-height: 34px;
  padding-left: 20px;
  pointer-events: none;
  position: absolute;
  top: 0;
  vertical-align: middle;
  width: 100%;
}
</style>